// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ActingProfile } from "../../../data/talent-core/acting-profile";
import { ActingProfileEthnicity } from "../../../data/talent-core/acting-profile-ethnicity";
import { ActingProfileCharacterType } from "../../../data/talent-core/acting-profile-character-type";
import { EnvelopeDocument } from "../base/envelope-document";

export class ActingProfileDocument extends EnvelopeDocument {
	public override Item: ActingProfile = new ActingProfile();
	public Ethnicities: ActingProfileEthnicity[] = [];
	public CharacterTypes: ActingProfileCharacterType[] = [];
}